//ITEMS
$(document).on('click', '.addserviciodocumento', function () {
    $("#listaServicios").modal("show");
    $("#listaServiciosLabel").empty();
    $("#servicios-lista").empty();
    $("#listaServiciosLabel").append("Lista de servicios");
    $.ajax({
        url: "servicios/aux/",
        type: "GET",
        dataType: "json",
        success: function (data) {
            $("#servicios-lista").append(`
                <div class="cabecera-lista border-bottom sticky-top px-3 py-2"> 
                    <div class='row g-0 align-items-center'>
                        <div class='col-8'>
                            <p class='m-0 small text-muted fw-bold text-uppercase tracking-wider'>Concepto / Servicio</p>
                        </div>
                        <div class='col-2 text-end'>
                            <p class='m-0 small text-muted fw-bold text-uppercase tracking-wider pe-3'>PVP</p>
                        </div>
                        <div class='col-2 text-center'>
                            <p class='m-0 small text-muted fw-bold text-uppercase tracking-wider'>Selección</p>
                        </div>
                    </div>
                </div>
            `);
            $.each(data, function (index, value) {
                var html = `
                    <div class="registro-lista px-3 py-2 border-bottom transition-all"> 
                        <div class='row g-0 align-items-center'>
                            <div class='col-8'>
                                <p class='m-0 fw-semibold text-main capitalise'>`+ value['nombre'] + `</p>
                            </div>
                            <div class='col-2 text-end pe-3'>
                                <p class='m-0 fw-black text-main font-monospace'>`+ value['precio'] + `€</p>
                            </div>
                            <div class="col-2 text-center">
                                <input type='checkbox' class="form-check-input shadow-sm" style="width: 1.25rem; height: 1.25rem;" value='`+ value['id'] + `'>
                            </div>
                        </div>
                    </div>
                `;
                $("#servicios-lista").append(html);
            });

        }
    });
});
$(document).on('click', "#confirmaddservicio", function () {
    var servicios = $("#listaServicios input");
    $.each(servicios, function (index, value) {
        if ($(value).is(':checked')) {
            $.ajax({
                url: "servicios/" + $(value).val(),
                type: "GET",
                dataType: "json",
                success: function (data) {
                    $(".items-documento").append(`
                        <div class="registro-items"> 
                            <div class="row g-0 align-items-center w-100">
                                <input name="input_item_id[]" class="d-none input-item-id" type='text' value='`+ data['id'] + `'>
                                <div class="col-1">
                                    <input name="input_item_cantidad[]" class="form-control text-center fw-bold bg-light input-item-cantidad" type='number' step='0.10' value='1'>
                                </div>    
                                <div class="col-4">
                                    <input type="text" name='input_item_concepto[]' class='form-control fw-semibold input-item-concepto ps-3' value='`+ data['nombre'] + `'>
                                </div>
                                <div class="col-2">
                                    <input name="input_item_precio[]" class="form-control text-end input-item-precio" type='number' step='0.01' value='`+ data['precio'] + `'>
                                </div>
                                <div class="col-1">
                                    <input name="input_item_descuento[]" class="form-control text-center text-slate-400 input-item-descuento" type='number' step='0.01' value='0'>
                                </div>
                                <div class="col-1">
                                    <input name="input_item_iva_porcentaje[]" class="form-control text-center text-slate-400 input-item-iva-porcentaje" type='number' step='0.01' value='`+ data['iva'] + `'>
                                    <input type="hidden" name="input_item_iva_importe[]" class="input-item-iva-importe" value="0">
                                </div>
                                <div class="col-2">
                                    <input type="number" step="0.01" name="input_item_importe[]" class='form-control text-end fw-black text-slate-900 input-item-importe' value='`+ data['precio'] + `'>
                                </div>
                                <div class="col-1 text-center">
                                    <a title='Borrar' class='btn btn-link text-danger p-0 borrar-item' href='#'><i class="bi bi-x-circle-fill fs-5"></i></a>
                                </div>
                            </div>
                        </div>
                    `);

                    recalculoimporte();
                },
                async: false
            });
        }
    });
    $("#listaServicios").modal('hide');
});
$(document).on('keyup', '#filtro-box-servicios', function () {
    var value = $(this).val().toLowerCase();
    $("#servicios-lista  .registro-lista").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});
$(document).on('click', '.borrar-item', function () {
    $(this).parent().parent().remove();
    recalculoimporte();
});
$(document).on('change', '.input-item-precio', function () {
    var valor_precio = $(this).val();
    var valor_descuento = $(this).parent().parent().find(".input-item-descuento").val();
    var valor_cantidad = $(this).parent().parent().find(".input-item-cantidad").val();
    $(this).parent().parent().find(".input-item-importe").val((valor_cantidad * valor_precio) - ((valor_cantidad * valor_precio) * valor_descuento / 100));
    recalculoimporte();
});
$(document).on('change', '.input-item-descuento', function () {
    var valor_descuento = $(this).val();
    var valor_precio = $(this).parent().parent().find(".input-item-precio").val();
    var valor_cantidad = $(this).parent().parent().find(".input-item-cantidad").val();
    $(this).parent().parent().find(".input-item-importe").val((valor_cantidad * valor_precio) - ((valor_cantidad * valor_precio) * valor_descuento / 100));
    recalculoimporte();
});
$(document).on('change', '.input-item-cantidad', function () {
    var valor_cantidad = $(this).val();
    console.log(valor_cantidad);
    var valor_descuento = $(this).parent().parent().find(".input-item-descuento").val();
    console.log(valor_descuento);
    var valor_precio = $(this).parent().parent().find(".input-item-precio").val();
    console.log(valor_precio);
    $(this).parent().parent().find(".input-item-importe").val((valor_cantidad * valor_precio) - ((valor_cantidad * valor_precio) * valor_descuento / 100));
    recalculoimporte();
});
$(document).on('change', '.input-item-importe, .input-item-iva-porcentaje, #irpf-porcentaje-documento', function () {
    recalculoimporte();
});
//FUNCIONES
window.recalculoimporte = function recalculoimporte() {
    var lineas = $('.registro-items');
    var subtotal = 0.00;
    var total_iva = 0.00;
    var ivas = {};
    
    $.each(lineas, function () {
        if ($(this).find('.input-item-importe').prop('disabled') == false) {
            var importe = parseFloat($(this).find('.input-item-importe').val()) || 0;
            var iva_porcentaje = parseFloat($(this).find('.input-item-iva-porcentaje').val()) || 0;
            var iva_importe = importe * (iva_porcentaje / 100);
            
            $(this).find('.input-item-iva-importe').val(iva_importe.toFixed(2));
            
            subtotal += importe;
            total_iva += iva_importe;

            if (!ivas[iva_porcentaje]) {
                ivas[iva_porcentaje] = 0;
            }
            ivas[iva_porcentaje] += iva_importe;
        }
    });

    // Update summary with breakdown
    $("#container-iva-desglose").empty();
    $.each(ivas, function(porcentaje, importe) {
        $("#container-iva-desglose").append(`
            <div class="summary-row py-1 border-bottom border-light">
                <label class="text-slate-500 m-0">IVA Aplicado (`+porcentaje+`%)</label>
                <div class="value-box bg-transparent border-0">
                    <input type="number" step="0.01" readonly class="text-end fw-bold text-slate-700 bg-transparent border-0" value="`+importe.toFixed(2)+`" style="width: 100px;">
                    <span class="text-slate-400">€</span>
                </div>
            </div>
        `);
    });
    $("#container-iva-desglose").append(`
        <input type="hidden" name="iva" id="iva-documento" value="`+total_iva.toFixed(2)+`">
    `);

    var irpf_porcentaje = 0;
    var tipoDocumento = $("#tipo-documento").val();
    if (tipoDocumento === "factura") {
        irpf_porcentaje = parseFloat($("#irpf-porcentaje-documento").val()) || 0;
    }
    var irpf_importe = subtotal * (irpf_porcentaje / 100);

    $("#subtotal-documento").val(subtotal.toFixed(2));
    $("#irpf-documento").val(irpf_importe.toFixed(2));
    if (tipoDocumento === "presupuesto") {
        $("#irpf-porcentaje-documento").val(0);
    }
    
    var total = subtotal + total_iva - irpf_importe;
    $("#total-documento").val(total.toFixed(2));
}

// Change event for Emisor selector
$(document).on('change', '#select-emisor', function () {
    var selectedOption = $(this).find('option:selected');
    var nombre = selectedOption.data('nombre');
    var cif = selectedOption.data('cif');
    var direccion = selectedOption.data('direccion');
    var cp = selectedOption.data('cp');
    var poblacion = selectedOption.data('poblacion');
    var logo = selectedOption.data('logo');

    // Update UI labels
    $(".cif-emisor").html(cif ? "NIF: " + cif : "");
    $(".direccion-emisor").html(direccion || "");
    $(".poblacion-emisor").html((cp || "") + " " + (poblacion || ""));
    
    // Update logo
    if (!logo) {
        $(".logo-documento img").attr('src', "storage/logo/nologo.jpg");
    } else {
        $(".logo-documento img").attr('src', "storage/" + logo);
    }
});


